import { Direction, Tab, Tabs, Typography, Theme, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { getApplicationDirection } from '../global.app.slice';
import {
  CcfBox,
  CcfDashboardIcon,
  CcfHeader,
  CcfTabs,
  useTranslator,
} from '@nice-ccf/ui-controls';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './ccf-reporting.module.scss';
import CcfProductivity from './ccf-productivity/ccf-productivity';
import CcfPerformance from './ccf-performance/ccf-performance';

/**
 * used to show App enlighten static screen in app space
 * @param props - CcfAppEnlightenProps
 * @example ` <CcfAppEnlighten />`
 */
function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
      style={{ marginTop: '10px' }}
    >
      {value === index && <Typography>{children}</Typography>}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
/* eslint-disable-next-line */
export interface CcfReportingProps {}
/**
 * used to show App enlighten static screen in app space
 * @param props - CcfAppEnlightenProps
 * @example ` <CcfAppEnlighten />`
 */
function a11yProps(index: any) {
  return {
    id: `wrapped-tab-${index}`,
    'aria-controls': `wrapped-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #dae2e8',
    boxShadow: '0px 1px 3px #00000029',
    borderRadius: '5px',
  },
  buttonActive: {
    '&.Mui-selected': {
      color: '#005C99',
    },
  },
}));
/**
 * used to show App enlighten static screen in app space
 * @param props - CcfAppEnlightenProps
 * @example ` <CcfAppEnlighten />`
 */
export function CcfReporting(props: CcfReportingProps) {
  const dispatch = useDispatch();
  const [translate] = useTranslator();
  const appDirection: Direction = useSelector(getApplicationDirection);
  const classes = useStyles();
  const reportingTabs = [
    {
      element: <CcfProductivity />,
      tooltip: translate('productivity'),
      isActive: true,
      menuName: translate('productivity'),
    },
    {
      element: <CcfPerformance />,
      tooltip: translate('performance'),
      isActive: false,
      menuName: translate('performance'),
    },
  ];
  const [currentTab, setCurrentTab] = useState(0);

  /**
   * Used to update the app space tab menuName and tab index
   * @param newTabIndex - number
   * @example - handleChange(0)
   */
  const handleChange = (newTabIndex: number) => {
    setCurrentTab(newTabIndex);
  };

  return (
    <CcfBox className={classes.root}>
      <div style={{ background: '#F5F8FA', maxHeight: '74px' }}>
        <CcfHeader
          LeftIcon={<CcfDashboardIcon />}
          headerText={translate('Reporting')}
          RightIcon
          direction={appDirection}
        ></CcfHeader>

        <CcfTabs
          currentTab={currentTab}
          // textColor={'#005C99'}
          variant={CcfTabs.Variant.STANDARD}
          setCurrentTab={handleChange}
          classes={{
            root: styles.tabsContainer,
            indicator: styles.activeTabIndicator,
          }}
          id={`agent_Reporting_${currentTab}_tab`}
        >
          {reportingTabs.map((tab, index) => (
            <CcfTabs.TabPanel key={index} label={tab.menuName}>
              <Box
                id={`agent_Reporting_${tab.element}_tab`}
                className={styles.tabLabel}
              >
                {tab.element}
              </Box>
            </CcfTabs.TabPanel>
          ))}
        </CcfTabs>
      </div>
    </CcfBox>
  );
}

export default CcfReporting;
